import { Theme, styled } from '@mui/material/styles';
import { Box } from '@mui/material';

type StyledChartWrapperType = {
  theme: Theme;
  isTablet: boolean;
};

const StyledChartWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTablet',
})(({ theme, isTablet }: StyledChartWrapperType) => ({
  boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  borderRadius: '16px',
  padding: isTablet ? '2rem 0.5rem' : '2rem 1rem',
  marginTop: '2rem',
  marginBottom: '2rem',
  backgroundColor: theme.palette.background.default,
  position: 'relative',
}));

const StyledChartHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTablet',
})(({ isTablet }: { isTablet: boolean }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: ' 2rem',
  padding: '0 0.5rem',
  position: 'relative',
  zIndex: '10',
  '@media (max-width:600px)': {
    padding: 0,
  },
}));

const boxIcon = {
  cursor: 'pointer',
  width: '30px',
  height: '30px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  '@media (max-width:600px)': {
    width: '24px',
    height: '24px',
  },
};

const iconsWrapper = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};

const StyledBoxPanIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isPanAndZoomActive',
})(({ theme, isPanAndZoomActive }: { theme: Theme; isPanAndZoomActive: boolean }) => ({
  cursor: 'pointer',
  width: '30px',
  height: '30px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: isPanAndZoomActive ? theme.palette.primary.lighter : 'none',
  borderRadius: '8px',
  flexShrink: 0,
  '@media (max-width:600px)': {
    width: '24px',
    height: '24px',
  },
}));

export { StyledChartWrapper, boxIcon, iconsWrapper, StyledChartHeader, StyledBoxPanIcon };
